<template>
    <!-- box with border radius and drop shadow -->
    <div class="" :class="getClass">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        width: {
            type: String,
            default: ''
        },
        rounded: {
            type: String,
            default: 'rounded-new'
        },
        useMinHeight: {
            type: Boolean,
            default: true
        },
        bgClassColor: {
            type: String,
            default: 'bg-white'
        },
        removeStyling: {
            type: Boolean,
            default: false
        },
        removeMaxWidth: {
            type: Boolean,
            default: false
        },
        padding: {
            type: String,
            default: 'p-4 lg:p-8'
        }
    },
    computed: {

        getClass() {
            const minHeight = this.useMinHeight ? ' min-h-500' : '';
            let contentClass = 'mx-auto' + minHeight;

            if(!this.removeStyling) {
                contentClass += ' shadow-2xl ' + this.padding;
            }

            if(!this.removeMaxWidth) {
                contentClass += ' max-w-4xl ';
            }

            contentClass += ' ' + this.bgClassColor;

            contentClass += ' ' + this.getRounded;


            return contentClass + ' ' + this.getWidth;
        },
        getWidth() {
            const xl = 'max-w-3xl';
            const lg = 'max-w-lg';
            const md = 'max-w-md';
            const sm = 'max-w-sm';
            const xs = 'max-w-xs';
            const full = 'w-full';

            switch (this.width) {
                case 'xl':
                    return xl;
                case 'lg':
                    return lg;
                case 'md':
                    return md;
                case 'sm':
                    return sm;
                case 'xs':
                    return xs;
                case 'full':
                    return full;
                default:
                    return 'w-full md:w-10/12 lg:w-3/4';
            }
        },

        getRounded() {
            const none = '';
            const lg = 'rounded-lg';
            const md = 'rounded-md';
            const full = 'rounded-full';
            
            switch (this.rounded) {
                case 'none':
                    return none;
                case 'lg':
                    return lg;
                case 'full':
                    return full;
                case 'md':
                    return md;
                default:
                    return 'rounded-new';
            }
        }
    }
}
</script>

<style scoped>
.app-box {
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
}
</style>